(function() {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  /* ========= helpers ========= */

  function formatMoney(amount, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, moneyFormat);
    }
    if (typeof moneyFormat === 'string' && moneyFormat.indexOf('{{amount}}') !== -1) {
      var num = (amount / 100).toFixed(2);
      return moneyFormat.replace('{{amount}}', num);
    }
    return (amount / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function() { return { items: [] }; });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return '';
    var ids = cart.items.map(function(i) {
      return i.product_id + 'x' + i.quantity;
    }).join('|');
    return cart.item_count + '::' + ids;
  }

  // мультиязычный URL для рекомендаций (учитываем префикс языка)
  function getRecommendationsUrl(productId, intent, limit) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    var base = root.replace(/\/?$/, '/');
    return (
      base +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=' + encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);

    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function() { return { products: [] }; });
  }

  // обновление цены при смене варианта в мини-селекторе
  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest('.cart-upsells__item');
    if (!card) return;

    var priceWrap = card.querySelector('.cart-upsells__price');
    if (!priceWrap) return;

    var root = card.closest('[data-cart-upsells-root]');
    var moneyFormat =
      (root && root.getAttribute('data-upsells-money-format')) ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute('data-price') || '0', 10);
    var compareAt = parseInt(opt.getAttribute('data-compare-at') || '0', 10);

    var html = '';
    if (compareAt && compareAt > price) {
      html =
        '<span class="cart-upsells__price-old">' + formatMoney(compareAt, moneyFormat) + '</span>' +
        '<span class="cart-upsells__price-new">' + formatMoney(price, moneyFormat) + '</span>';
    } else {
      html =
        '<span class="cart-upsells__price-regular">' + formatMoney(price, moneyFormat) + '</span>';
    }

    priceWrap.innerHTML = html;
  }

  /* ========= upsell cards ========= */

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function(p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return '';

    return picked.map(function(p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;

      if (img && typeof img === 'string') {
        imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, '_160x.');
      } else if (img && img.src) {
        imgUrl = img.src;
      }

      var title = p.title || '';
      var words = title.split(' ').filter(function(w){ return w.length; });
      var shortWords = words.slice(0, 5);
      var shortTitle = shortWords.join(' ');
      if (words.length > 5) {
        shortTitle += '…';
      }

      var variants = p.variants || [];
      var fav = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) {
          fav = variants[i];
          break;
        }
      }
      if (!fav && variants.length) fav = variants[0] || null;

      var selectedVariant = fav || null;

      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var priceHtml = '';
      if (baseCompareAt && baseCompareAt > basePrice) {
        priceHtml =
          '<span class="cart-upsells__price-old">' + formatMoney(baseCompareAt, moneyFormat) + '</span>' +
          '<span class="cart-upsells__price-new">' + formatMoney(basePrice, moneyFormat) + '</span>';
      } else {
        priceHtml =
          '<span class="cart-upsells__price-regular">' + formatMoney(basePrice, moneyFormat) + '</span>';
      }

      var hasMultipleVariants = variants.length > 1;
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || '';
      var productUrl = p.url || (handle ? ('/products/' + handle) : '#');

      // мини-селектор варианта для мультивариантных
      var selectorHtml = '';
      if (hasMultipleVariants) {
        selectorHtml += '<select class="cart-upsells__variant-select" data-upsell-variant-select>';
        variants.forEach(function(v) {
          if (!v) return;
          var optLabel = v.public_title || v.title || '';
          selectorHtml +=
            '<option value="' + v.id + '"' +
              (selectedVariantId && String(v.id) === String(selectedVariantId) ? ' selected' : '') +
              ' data-price="' + (v.price || 0) + '"' +
              ' data-compare-at="' + (v.compare_at_price || 0) + '">' +
              optLabel +
            '</option>';
        });
        selectorHtml += '</select>';
      }

      // кнопка +: для одиночного варианта — сразу с variant-id; для мульти — берем из селектора
      var buttonHtml = '';
      if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" ' +
            'data-cart-upsell-add data-variant-id="' + selectedVariant.id + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
          '</button>';
      } else {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add>' +
            '<span class="cart-upsells__add-icon">+</span>' +
          '</button>';
      }

      return '' +
        '<div class="cart-upsells__item">' +
          '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, '&quot;') + '">' : '') +
          '</a>' +
          '<div class="cart-upsells__content">' +
            '<a href="' + productUrl + '" class="cart-upsells__title" data-instant>' +
              shortTitle +
            '</a>' +
            '<div class="cart-upsells__bottom-row">' +
              '<div class="cart-upsells__price">' + priceHtml + '</div>' +
              (selectorHtml || '') +
            '</div>' +
          '</div>' +
          buttonHtml +
        '</div>';
    }).join('');
  }

  /* ========= render upsells ========= */

  var lastSignature = null;
  var updating = false;

  function renderCartUpsells() {
    if (updating) return;
    updating = true;

    var root = document.querySelector('[data-cart-upsells-root]');
    if (!root) {
      updating = false;
      return;
    }

    var listEl = root.querySelector('[data-cart-upsells-list]');
    if (!listEl) {
      updating = false;
      return;
    }

    var intent = root.getAttribute('data-upsells-intent') || 'complementary';
    var limit = parseInt(root.getAttribute('data-upsells-limit') || '3', 10);
    var moneyFormat =
      root.getAttribute('data-upsells-money-format') ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    fetchCart().then(function(cart) {
      var sig = cartSignature(cart);
      if (sig === lastSignature && listEl.children.length) {
        updating = false;
        return;
      }
      lastSignature = sig;

      // корзина пустая — полностью прячем блок
      if (!cart || !cart.items || !cart.items.length) {
        root.style.display = 'none';
        listEl.innerHTML = '';
        updating = false;
        return;
      }

      root.style.display = '';
      listEl.innerHTML = '';

      var inCartProductIds = cart.items.map(function(i){ return i.product_id; });
      var allRecs = [];
      var productIds = inCartProductIds.slice();
      var idx = 0;

      function step() {
        if (idx >= productIds.length || allRecs.length >= limit * 3) {
          var html = buildCardsHtml(allRecs, inCartProductIds, moneyFormat, limit);
          if (!html) {
            root.style.display = 'none';
            listEl.innerHTML = '';
          } else {
            root.style.display = '';
            listEl.innerHTML = html;

            // после рендера синхронизируем цены для всех селектов
            var selects = listEl.querySelectorAll('[data-upsell-variant-select]');
            selects.forEach(function(sel) {
              updateUpsellPriceFromSelect(sel);
            });
          }
          updating = false;
          return;
        }

        var pid = productIds[idx++];
        fetchRecommendationsForProduct(pid, intent, limit).then(function(data) {
          if (data && Array.isArray(data.products)) {
            allRecs = allRecs.concat(data.products);
          }
          step();
        }).catch(function() {
          step();
        });
      }

      step();
    }).catch(function() {
      updating = false;
    });
  }

  /* ========= перерисовка самого cart-drawer из секции ========= */

  function getCartDrawerSectionIds() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return null;

    var node = drawer;
    while (node && node !== document.documentElement) {
      if (node.id && node.id.indexOf('shopify-section-') === 0) {
        return {
          domId: node.id,
          sectionId: node.id.replace('shopify-section-', '')
        };
      }
      node = node.parentElement;
    }
    return null;
  }

  function setupDrawerMutationObserver() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var itemsHolder = drawer.querySelector('[data-items-holder]');
    if (!itemsHolder) return;

    if (window.CustomCartUpsellsItemsObserver) {
      window.CustomCartUpsellsItemsObserver.disconnect();
    }

    var observer = new MutationObserver(function(muts) {
      var changed = muts.some(function(m){ return m.type === 'childList'; });
      if (changed) {
        renderCartUpsells();
      }
    });

    observer.observe(itemsHolder, { childList: true, subtree: true });
    window.CustomCartUpsellsItemsObserver = observer;
  }

  function refreshCartDrawerFromSection(detail) {
    var ids = getCartDrawerSectionIds();
    if (!ids) {
      renderCartUpsells();
      return Promise.resolve();
    }

    var sectionDomId = ids.domId;
    var sectionId = ids.sectionId;

    return fetch('/?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(json){
        if (!json || !json[sectionId]) {
          renderCartUpsells();
          return;
        }

        var html = json[sectionId];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var freshSection = tmp.querySelector('#' + sectionDomId) || tmp.firstElementChild;
        if (!freshSection) {
          renderCartUpsells();
          return;
        }

        var freshDrawer = freshSection.querySelector('#cart-drawer');
        if (!freshDrawer) {
          renderCartUpsells();
          return;
        }

        var tpl = freshDrawer.querySelector('[data-cart-drawer-template]');
        var newInner;
        if (tpl) {
          newInner = tpl.innerHTML;
        } else {
          newInner = freshDrawer.innerHTML;
        }

        var liveDrawer = document.getElementById('cart-drawer');
        if (!liveDrawer) {
          renderCartUpsells();
          return;
        }

        liveDrawer.innerHTML = newInner;

        // пересоздаём наблюдатель на новые item’ы
        setupDrawerMutationObserver();

        var root = document.documentElement || document;
        ['cart:updated','cart:refresh','ajaxProduct:added','product:added'].forEach(function(name){
          try {
            root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || null }));
          } catch (e) {}
        });

        renderCartUpsells();
      })
      .catch(function() {
        renderCartUpsells();
      });
  }

  /* ========= клики по кнопкам в апсейлах ========= */

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;

    // пробуем взять variant-id прямо с кнопки (одновариантные товары)
    var variantId = button.getAttribute('data-variant-id');

    // если его нет — ищем мини-селектор варианта в карточке
    if (!variantId) {
      var card = button.closest('.cart-upsells__item');
      if (card) {
        var select = card.querySelector('[data-upsell-variant-select]');
        if (select) {
          variantId = select.value;
        }
      }
    }

    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      credentials: 'same-origin'
    })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        button.disabled = false;
        return refreshCartDrawerFromSection(data);
      })
      .catch(function() {
        button.disabled = false;
      });
  });

  // смена варианта в мини-селекторе → обновляем цену
  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-upsell-variant-select]');
    if (!select) return;
    updateUpsellPriceFromSelect(select);
  });

  /* ========= триггеры рендера апсейлов ========= */

  ['cart-drawer:open', 'cart:updated', 'cart:refresh', 'ajaxProduct:added', 'cart:change']
    .forEach(function(evt) {
      document.addEventListener(evt, function() {
        renderCartUpsells();
      });
    });

  // когда в DOM появляется блок с data-cart-upsells-root (дровер собрался из template)
  var mo = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      (m.addedNodes || []).forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-cart-upsells-root]')) {
          setupDrawerMutationObserver();
          renderCartUpsells();
        } else if (node.querySelector && node.querySelector('[data-cart-upsells-root]')) {
          setupDrawerMutationObserver();
          renderCartUpsells();
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // стартовый рендер + наблюдатель за изменением товаров
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupDrawerMutationObserver();
      renderCartUpsells();
    });
  } else {
    setupDrawerMutationObserver();
    renderCartUpsells();
  }
})();
